'use strict';
module.exports = function () {
    $(document).ready(function () {
        $('.zoom').zoom();
    });
};
